import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {HttpStatusCodes} from '../../util/uiconstants';

export default function engagementTagGroupsReducer(state = initialstate.engagementTagGroups, action) {
	switch (action.type) {
		case types.GET_ALL_TAG_GROUPS: {
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				return action.response;
			}
			return state;
		}
		default:
			return state;
	}
}
